import { createApp } from 'vue';
import { initGrowthbook } from '@/lib/growthbook';
import { setupBraze } from '../lib/braze';

export async function initializeClientIntegrations() {
  try {
    setupBraze();
  } catch (error) {
    console.warn('Braze setup failed:', error);
  }

  try {
    await initGrowthbook();
  } catch (error) {
    console.warn('GrowthBook setup failed:', error);
  }
}

export function createSittercityApp(rootComponent: any) {
  return createApp(rootComponent);
}
